import { useAppDispatch } from '@/app/hooks';
import { debounce } from 'lodash-es';
import useTranslation from 'next-translate/useTranslation';
import { ChangeEvent } from 'react';
import { setMaxYear, setMinYear } from './ProductsFilter/productsFilterSlice';

/* eslint-disable no-unused-vars */
export function YearFilter() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  function handleSetMinYear(e: ChangeEvent<HTMLInputElement>) {
    dispatch(setMinYear(event2Int(e)));
  }
  function handleSetMaxYear(e: ChangeEvent<HTMLInputElement>) {
    dispatch(setMaxYear(event2Int(e)));
  }
  function event2Int(e: ChangeEvent<HTMLInputElement>) {
    return parseInt(e.target.value) ? parseInt(e.target.value) : null;
  }

  const debounceSetMinYear = debounce(handleSetMinYear, 500);
  const debounceSetMaxYear = debounce(handleSetMaxYear, 500);

  return (
    <div className='w-full items-center justify-between py-3 text-sm text-gray-400 hover:text-gray-500'>
      <h3 className='my-6 font-medium text-gray-900'>{t('common:Year')}</h3>
      <div className='space-y-4'>
        <div className='flex items-center space-x-4'>
          <input
            id={`filter-min-year`}
            name={`minYear`}
            type='number'
            className='text-indigo-600 focus:ring-indigo-500 h-8 w-full appearance-none rounded border-gray-300'
            placeholder='Min'
            min={1970}
            max={new Date().getFullYear()}
            onChange={debounceSetMinYear}
          />
          <input
            id={`filter-max-year`}
            name={`maxYear`}
            type='number'
            className='text-indigo-600 focus:ring-indigo-500 h-8 w-full appearance-none rounded border-gray-300'
            placeholder='Max'
            max={new Date().getFullYear()}
            onChange={debounceSetMaxYear}
            min={1970}
          />
        </div>
      </div>
    </div>
  );
}
